import { Store } from "pullstate";

import { RadioStoreInterface } from "@/helpers/pageHelpers/Store/interface";

export const RadioStore = new Store<RadioStoreInterface>({
  currentTrack: null,
  originalHistory: [],
});

// registerInDevtools({
//   RadioStore,
// });
